import "./style.scss"
const eadlineCom = ({ name }) => {
    return (<div className="eadline">
        <div>{name}</div>
        <div className="line"></div>
    </div>)
}
export default eadlineCom;